<template>
    <div class="row">
        <div class="col-12 mx-auto">
            <div class="bg-card rounded border-0" v-if="weekNumber">
                <div class="card-header">
                    <div class="row">
                        <div class="col-12 text-heading font-semibold">
                            <button class="btn btn-sm btn-neutral" @click="back">
                                <i class="bi bi-arrow-left"></i> {{ $trans.get('__JSON__.Back') }}
                            </button>
                            <span class="m-4">
                                {{ $trans.get('__JSON__.Week :number', { number: weekNumber }) }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="card-body p-0">
                    <div class="table-responsive" v-if="Object.keys(rows).length > 0">
                        <table class="table table-hover table-nowrap">
                            <thead class="thead-light">
                            <tr>
                                <th scope="col">
                                    {{ $trans.get('__JSON__.Starts At') }}
                                </th>
                                <th scope="col">
                                    {{ $trans.get('__JSON__.Ends At') }}
                                </th>
                                <th scope="col">
                                    {{ $trans.get('__JSON__.Job') }}
                                </th>
                                <th scope="col">
                                    {{ $trans.get('__JSON__.Hours') }}
                                </th>
                                <th scope="col">
                                    {{ $trans.get('__JSON__.Hours Worked') }}
                                </th>
                                <th scope="col"></th>
                            </tr>
                            </thead>
                            <tfoot>
                            <tr>
                                <td colspan="3"></td>
                                <th>{{ $trans.get('__JSON__.Total') }}</th>
                                <td>{{ totalHours }}</td>
                            </tr>
                            </tfoot>
                            <tbody>
                            <tr v-for="item in rows">
                                <td v-html="item.start_human"></td>
                                <td v-html="item.end_human"></td>
                                <td>
                                    <span class="text-heading font-semibold">
                                        {{ item.job }}
                                    </span>
<!--                                    <span class="d-block">-->
<!--                                        {{ item.client }}-->
<!--                                    </span>-->
<!--                                    <span class="d-block">-->
<!--                                        {{ item.location }}-->
<!--                                    </span>-->
                                </td>
                                <td>
                                    {{ item.duration }}
                                </td>
                                <td>
                                    {{ item.hours_worked }}
                                    <span class="badge bg-danger" v-if="item.status === 'conflict'">{{ item.status }}</span>
                                </td>
                                <td class="text-end">
                                    <div class="btn-group">
                                        <button type="button" class="btn btn-sm btn-neutral" v-for="button in item.buttons" @click="handleAction(button, item)">
                                            {{ button.label }}
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="text-center pb-5" v-else-if="loading">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">{{ $trans.get('__JSON__.Loading...') }}</span>
                        </div>
                    </div>
                    <div class="text-center pb-5" v-else>
                        <em>{{ $trans.get('__JSON__.No records found to show') }}</em>
                    </div>
                </div>
            </div>

            <div class="bg-card rounded border-0" v-else>
                <div class="card-header">
                    <div class="row">
                        <div class="col-10 text-heading font-semibold">
                            {{ $trans.get('__JSON__.Past Shifts') }}
                        </div>
                        <div class="col-2">
                            <select class="form-select" @change="year = parseInt($event.target.value)" v-model="year">
                                <option :value="current" v-for="current in years">{{ current }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="card-body p-0">
                    <div class="table-responsive" v-if="Object.keys(rows).length > 0">
                        <table class="table table-hover table-nowrap">
                            <thead class="thead-light">
                            <tr>
                                <th scope="col">
                                    {{ $trans.get('__JSON__.Week Number') }}
                                </th>
                                <th scope="col">
                                    {{ $trans.get('__JSON__.Worked Hours') }}
                                </th>
<!--                                <th scope="col">-->
<!--                                    {{ $trans.get('__JSON__.Payout') }}-->
<!--                                </th>-->
<!--                                <th scope="col">-->
<!--                                    {{ $trans.get('__JSON__.Payout Date') }}-->
<!--                                </th>-->
                                <th scope="col"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in rows">
                                <td>
                                    <span class="text-heading font-semibold">
                                        {{ item.week }}
                                    </span>
                                </td>
                                <td>
                                    {{ item.hours }}
                                </td>
<!--                                <td>-->
<!--                                    <span class="text-heading font-semibold">-->
<!--                                        {{ item.payout }}-->
<!--                                    </span>-->
<!--                                </td>-->
<!--                                <td>-->
<!--                                    {{ item.payout_date }}-->
<!--                                </td>-->
                                <td class="text-end">
                                    <div class="btn-group">
                                        <button type="button" class="btn btn-sm btn-neutral" v-for="button in item.buttons" @click="handleAction(button, item)">
                                            {{ button.label }}
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="text-center pb-5" v-else-if="loading">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">{{ $trans.get('__JSON__.Loading...') }}</span>
                        </div>
                    </div>
                    <div class="text-center pb-5" v-else>
                        <em>{{ $trans.get('__JSON__.No records found to show') }}</em>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <MutationCorrectionModal :user="user" :enrollment="enrollment" ref="correct" />

    <MutationDetailsModal :enrollment="enrollment" />
</template>

<script>
import MutationCorrectionModal from '@/components/shared/MutationCorrectionModal'
import MutationDetailsModal from '@/components/shared/MutationDetailsModal'

export default {
    name: 'PastShifts',
    components: { MutationCorrectionModal, MutationDetailsModal },
    data() {
        return {
            loading: false,
            view: 'overview',
            weekNumber: null,
            rows: [],
            totalHours: 0,
            year: null,
            years: [],
            enrollment: null,
            user: null,
        }
    },
    watch: {
        year() {
            this.fetchOverview()
        },
        weekNumber() {
            if (this.weekNumber) this.fetchWeek()
            else this.fetchOverview()
        },
    },
    methods: {
        handleAction(button, item) {
            if (button.id === 'details') {
                this.view = 'week'
                this.weekNumber = item.week_number
            } else if (button.id === 'correct') {
                this.enrollment = item
                window.bootstrap.Modal.getOrCreateInstance(document.getElementById('correct_modal')).show()
            } else if (button.id === 'mutations') {
                this.enrollment = item
                window.bootstrap.Modal.getOrCreateInstance(document.getElementById('mutation_modal')).show()
            }
        },
        performAction(action) {
            if (action === 'correct') {
                const correct = this.$refs.correct
                const amount = correct.$refs.correct_amount.value,
                    type = correct.$refs.correct_type.value,
                    reason = correct.$refs.correct_reason.value,
                    button = correct.$refs.correct_submit

                return this.makeRequest('correct', button, { type, amount, reason }, () => {
                    window.bootstrap.Modal.getOrCreateInstance(document.getElementById('correct_modal')).hide()
                    correct.$refs.correct_amount.value = ''
                    correct.$refs.correct_type.value = 'more'
                    correct.$refs.correct_reason.value = ''
                    this.fetchWeek()
                })
            }
        },
        makeRequest(action, button, context = {}, closure = () => {}) {
            let data = {
                action,
                enrollment: this.enrollment.id,
            }

            const buttonText = button.innerHTML
            button.setAttribute('disabled', true)
            button.innerHTML = '<div class="spinner-border spinner-border-sm text-primary" role="status"></div>'

            return axios.post('/api/shifts/past/action', Object.assign(data, context))
                .then(response => closure(response))
                .catch(error => window.toastr.error(error.response.data.message ?? this.$trans.get('__JSON__.Something went wrong'), '', {
                    positionClass: 'toast-bottom-right',
                }))
                .finally(() => {
                    button.innerHTML = buttonText
                    button.removeAttribute('disabled')
                })
        },
        fetchWeek() {
            this.rows = []
            this.totalHours = 0
            this.fetch({ view: this.view, week: this.weekNumber, year: this.year }, response => {
                this.rows = response.data.rows
                this.totalHours = response.data.totalHours
            })
        },
        fetchOverview() {
            this.rows = []
            this.fetch({ view: this.view, year: this.year }, response => {
                const data = response.data
                this.rows = data.rows
                this.year = data.year
                this.years = data.years
            })
        },
        fetch(data, closure) {
            this.loading = true
            axios.post('/api/shifts/past', data).then(response => closure(response))
                .catch(error => window.toastr.error(error.response.data.message ?? this.$trans.get('__JSON__.Something went wrong'), '', {
                    positionClass: 'toast-bottom-right',
                }))
                .finally(() => this.loading = false)
        },
        back() {
            this.view = 'overview'
            this.weekNumber = null
        },
    },
    mounted() {
        this.fetchOverview()
    },
}
</script>
